import { CommonModule } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatOption, MatSelect } from '@angular/material/select';
import { LayoutService } from 'src/app/service/layout.service';
import { PhonePipe } from 'src/app/shared/pipes/phone.pipe';

@Component({
  selector: 'app-choose-phone-to-message',
  standalone: true,
  imports: [
    CommonModule,

    PhonePipe,

    MatDialogTitle,
    MatDialogContent,
    MatFormFieldModule,
    MatSelect,
    MatOption,
    MatDialogActions,
    MatDialogClose,
    MatButton
  ],
  templateUrl: './choose-phone-to-message.component.html',
  styleUrl: './choose-phone-to-message.component.scss'
})
export class ChoosePhoneToMessageComponent implements OnInit {

  phones: [string, string];

  constructor (
    @Inject(MAT_DIALOG_DATA) private data: [string, string],
    private _dialogRef: MatDialogRef<ChoosePhoneToMessageComponent>,
    private _layout: LayoutService,
  ) {
    this.phones = data;
  }

  ngOnInit(): void {
    this._layout.loader = false;
  }

  onNoClick(): void {
    this._dialogRef.close(null);
  }
}
